// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2p07i","footer":"styles_footer__juIdq","passCodeTooltip":"styles_passCodeTooltip__ClahV"};